
const getAchieves = state => state.masterProfile.achieves;
export const Selectors = {
  getAchieves,
}
